(function () {
  'use strict';
  function overlaps(a, b, gap) {
    return b.width > 0 && b.height > 0 && a.left < b.right + gap && a.right > b.left - gap && a.top < b.bottom + gap && a.bottom > b.top - gap;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { overlaps: overlaps };
  if (typeof document === 'undefined') return;
  var mobile = window.matchMedia('(max-width: 768px)');
  var frame = 0;
  function update() {
    frame = 0;
    var widgets = document.querySelectorAll('.rq-whatsapp-chat-container');
    var bar = document.querySelector('.qr-mobile-buy');
    var offset = mobile.matches && bar && getComputedStyle(bar).display !== 'none' ? Math.ceil(bar.getBoundingClientRect().height) + 12 : 0;
    var buttons = document.querySelectorAll('[data-product-add], [data-checkout]');
    widgets.forEach(function (widget) {
      widget.style.setProperty('--rq-purchase-offset', offset + 'px');
      var rect = widget.getBoundingClientRect();
      var blocked = mobile.matches && Array.from(buttons).some(function (button) {
        return getComputedStyle(button).visibility !== 'hidden' && overlaps(rect, button.getBoundingClientRect(), 12);
      });
      widget.toggleAttribute('data-purchase-overlap', blocked);
    });
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  mobile.addEventListener('change', schedule);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedule, { passive: true });
    window.visualViewport.addEventListener('scroll', schedule, { passive: true });
  }
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  if (window.ResizeObserver) new ResizeObserver(schedule).observe(document.body);
  schedule();
}());
